import Box from "@mui/material/Box";
import { memo } from "react";
import SimpleBar from "simplebar-react";

import { SidebarDrawer } from "@/layout/styles";

import MenuContent from "./MenuContent";
import SidebarLogo from "./SidebarLogo";

const Sidebar = memo(() => {
  return (
    <SidebarDrawer variant="permanent">
      <SidebarLogo />
      <Box component={SimpleBar}>
        <MenuContent />
      </Box>
    </SidebarDrawer>
  );
});
Sidebar.displayName = "Sidebar";

export default Sidebar;
